"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ArrowBack_exports = {};
__export(ArrowBack_exports, {
  default: () => ArrowBack_default
});
module.exports = __toCommonJS(ArrowBack_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.85156 11.0898L9.42578 14.6641C9.58203 14.8203 9.66016 15.0156 9.66016 15.25C9.66016 15.4844 9.58203 15.6797 9.42578 15.8359C9.25651 16.0052 9.05469 16.0898 8.82031 16.0898C8.59896 16.0898 8.40365 16.0052 8.23438 15.8359L3.23438 10.8359C3.07812 10.6797 3 10.4844 3 10.25C3 10.0156 3.07812 9.82031 3.23438 9.66406L8.23438 4.66406C8.40365 4.49479 8.59896 4.41016 8.82031 4.41016C9.05469 4.41016 9.25651 4.49479 9.42578 4.66406C9.58203 4.82031 9.66016 5.01562 9.66016 5.25C9.66016 5.48438 9.58203 5.67969 9.42578 5.83594L5.85156 9.41016H17.1602C17.3945 9.41016 17.5898 9.49479 17.7461 9.66406C17.9154 9.82031 18 10.0156 18 10.25C18 10.4844 17.9154 10.6862 17.7461 10.8555C17.5898 11.0117 17.3945 11.0898 17.1602 11.0898H5.85156Z",
      fill: "currentColor"
    }
  )
);
const SvgArrowBack = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ArrowBack_default = SvgArrowBack;
